import { normalize, schema } from 'normalizr';

const listingSchema = new schema.Entity('listings', {}, {
  idAttribute: listing => listing.ListingId
});

const listingsCountSchema = new schema.Entity('listingcounts', {}, {
  idAttribute: listing => `${'all'}`
});

const violationsSchema = new schema.Entity('violations', {}, {
  idAttribute: listing => `${'all'}`
});

const violatedListingSchema = new schema.Entity('violatedlisting', {}, {
  idAttribute: listing => listing.Date
});

const listingImageSchema = new schema.Entity('listingimages', {}, {
  idAttribute: listing => listing.ListingId
});

const violationTypeSchema = new schema.Entity('violationtypes', {}, {
  idAttribute: type => type.Id
});

const fhaKeywordSchema = new schema.Entity('fhakeywords', {}, {
  idAttribute: type => type.Id
});

const correctedListingSchema = new schema.Entity('correctedlistings', {}, {
  idAttribute: listing => listing.ListingId
});

const nonApprovedNotificationSchema = new schema.Entity('nonapprovednotifications', {}, {
  idAttribute: listing => listing.ListingId
});

const brokerOverrideEmailSchema = new schema.Entity('brokeroverrideemails', {}, {
  idAttribute: type => type.EmailMapperId
});

const brokerOverrideCompanySchema = new schema.Entity('brokeroverridecompanies', {}, {
  idAttribute: type => type.Id
});

const brokerOverrideBrokerSchema = new schema.Entity('brokeroverridebrokers', {}, {
  idAttribute: type => type.Id
});

const personalInfoWhiteListSchema = new schema.Entity('personalinfowhitelist', {}, {
  idAttribute: type => type.Id
});

//const listingArraySchema = { Listings: new schema.Array(listingSchema) };
//const violatedListingArraySchema = { Listings: new schema.Array(violatedListingSchema) };

export const Schemas = {
  LISTING: listingSchema,
  LISTING_ARRAY: [listingSchema],
  LISTINGS_COUNT: listingsCountSchema,
  VIOLATIONS: violationsSchema,
  VIOLATED_LISTING: violatedListingSchema,
  VIOLATED_LISTING_ARRAY: [violatedListingSchema],
  LISTING_IMAGE: listingImageSchema,
  LISTING_IMAGE_ARRAY: [listingImageSchema],
  VIOLATION_TYPE: violationTypeSchema,
  VIOLATION_TYPE_ARRAY: [violationTypeSchema],
  FHAKEYWORD_TYPE: fhaKeywordSchema,
  FHAKEYWORD_ARRAY: [fhaKeywordSchema],
  CORRECTED_LISTING: correctedListingSchema,
  CORRECTED_LISTING_ARRAY: [correctedListingSchema],
  NON_APPROVED_NOTIFICATION: nonApprovedNotificationSchema,
  NON_APPROVED_NOTIFICATION_ARRAY: [nonApprovedNotificationSchema],
  BROKER_OVERRIDE_TYPE: brokerOverrideEmailSchema,
  BROKER_OVERRIDE_ARRAY: [brokerOverrideEmailSchema],
  BROKER_OVERRIDE_COMPANY_TYPE: brokerOverrideCompanySchema,
  BROKER_OVERRIDE_COMPANY_ARRAY: [brokerOverrideCompanySchema],
  BROKER_OVERRIDE_BROKER_TYPE: brokerOverrideBrokerSchema,
  BROKER_OVERRIDE_BROKER_ARRAY: [brokerOverrideBrokerSchema],
  PERSONAL_INFO_WHITE_LIST_TYPE: personalInfoWhiteListSchema,
  PERSONAL_INFO_WHITE_LIST_ARRAY: [personalInfoWhiteListSchema],
};

export const CALL_API = 'Call API';

const callApi = (endpoint, schema, options) => {
  const API_ROOT = window.sessionStorage.getItem('RootAPI');
  return fetch(API_ROOT + endpoint, options)
    .then(response =>
      response.json().then(json => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        if (schema) {
          return normalize(json, schema);
        }
        else {
          return json;
        }

      })
    );
};

export default store => next => action => {
  const callAPI = action[CALL_API];

  if (typeof callAPI === 'undefined') {
    return next(action);
  }

  const { endpoint, schema, types, method, body } = callAPI;

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.');
  }
  if (!method) {
    throw new Error('Specify a method for api call.');
  }
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.');
  }
  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.');
  }

  const options = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'//,
      //'Authorization': 'Bearer ' + window.sessionStorage.getItem('APIKey')
    },
    method
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  const actionWith = data => {
    const finalAction = { ...action, ...data };
    delete finalAction[CALL_API];
    return finalAction;
  };

  const [requestType, successType, failureType] = types;
  next(actionWith({ type: requestType }));

  return callApi(endpoint, schema, options).then(
    response => next(actionWith({
      response,
      type: successType
    })),
    error => next(actionWith({
      type: failureType,
      error: error.ExceptionMessage || error.ErrorMessage || (error[0] && error[0].ErrorMessage) || 'An error has occurred.'
    }))
  );
}
